import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		VyrobekndOzn: [],
		ProvozovnaId: [],
		SkladOzn: []
	},

	filter: {
		PseudoNdPrp: null as boolean | null,
		VyrobekndOzn: null as string | null,
		NdNr: null as string | null,
		Text: null as string | null,
		EanCode: null as string | null,
		ProvozovnaId: null as number | null,
		SkladOzn: null as number | null
	},
	tableSetting: {},
	localState: {},
	rowDetail: null,
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
		filter: {},
		afterRowSelection: () => {},
	},
});
